// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"b95699aa","453":"d66ab290"}[chunkId] + ".chunk.js";
};